import { ArrowUp, Mail, MapPin } from "lucide-react";
import { scrollToTarget } from "@/App";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-obsidian overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-12 mb-20">
          <div className="md:col-span-6">
            <img
              src="/images/logo.jpg"
              alt="Giango — creatività applicata"
              className="h-24 w-auto rounded-xl border border-white/10"
              data-testid="footer-logo"
            />
            <p className="mt-6 text-zinc-400 max-w-sm leading-relaxed">
              Il primo studio di creatività applicata: soluzioni creative, mirate ed efficaci per la comunicazione e la formazione della tua azienda.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-6">
              Naviga
            </p>
            <ul className="space-y-3.5">
              {[
                { label: "Manifesto", href: "#manifesto" },
                { label: "Chi sono", href: "#chi-siamo" },
                { label: "Servizi", href: "#servizi" },
                { label: "Approccio", href: "#approccio" },
                { label: "Contatti", href: "#contatti" },
              ].map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => scrollToTarget(l.href)}
                    className="text-zinc-400 hover:text-ember transition-colors duration-300 text-sm"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500 mb-6">
              Contatti
            </p>
            <ul className="space-y-4 text-sm">
              <li data-testid="footer-address-info" className="flex items-start gap-3 text-zinc-400">
                <MapPin className="h-4 w-4 mt-0.5 text-ember shrink-0" aria-hidden="true" />
                Via Ferruccio Busoni 8, Milano
              </li>
              <li data-testid="footer-email-link">
                <a
                  href="mailto:giango@giango.it"
                  className="flex items-start gap-3 text-zinc-400 hover:text-ember transition-colors duration-300"
                >
                  <Mail className="h-4 w-4 mt-0.5 text-ember shrink-0" aria-hidden="true" />
                  giango@giango.it
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 border-t border-white/10 pt-8">
          <p className="font-mono text-[11px] text-zinc-600">
            © {new Date().getFullYear()} Giango — Tutti i diritti riservati.
          </p>
          <button
            data-testid="footer-back-to-top"
            onClick={() => scrollToTarget(0)}
            className="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500 hover:text-ember transition-colors duration-300"
          >
            Torna su
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 group-hover:border-ember transition-colors duration-300">
              <ArrowUp className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5" aria-hidden="true" />
            </span>
          </button>
        </div>
      </div>
    </footer>
  );
}
